import {
  searchAutocompleteBlueprint,
  searchShanghaiBlueprint,
} from "@made-people/blueprint-search/blueprint";

searchShanghaiBlueprint.override({
  slots: {
    heading:
      "font-secondary text-heading-xl lg:text-heading-2xl text-center pt-12 pb-4 px-8",
    searchInputWrapper: "hidden",
  },
});

searchAutocompleteBlueprint.override({
  slots: {
    wrapper:
      "bg-white rounded-2xl py-3 absolute w-full mt-2 overflow-hidden z-10 lg:hidden",
    heading: "px-4 hidden",
    resultList: "mt-4 grid grid-cols-2 px-4 gap-x-2 overflow-scroll h-[70dvh]",
    itemImage: "block aspect-product-image rounded-sm",
    itemLabel: "",
    item: "col-span-1 flex flex-col",
    emptyStateWrapper:
      "flex flex-col items-start justify-start lg:justify-start w-full col-span-2 max-h-[60dvh]",
    emptyStateHeading: " text-body-lg",
    loading: "text-body-lg",
  },
});
